// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
  specErrorMessage: '',
};
const initialState = {
  ...resetState,
  isLoading: false,
  specErrorMessage: '',
};

const getValidationErrorMessage = (payload) => get(payload, 'errors.detail.validationErrors[0].error');

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.API_SETTINGS_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        errors: [],
      };
    case Constants.API_SETTINGS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        enforceCategoryOrderingData: action.payload,
      };
    case Constants.API_SETTINGS_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_REQUEST:
        return {
          ...state,
          isLoading: true,
          isError: false,
          errors: [],
        };
    case Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isError: false,
          specErrors: [],
          specDefaultProxyData: action.payload,
        };
    case Constants.API_SETTINGS_SPEC_DEFAULT_PROXY_GET_ERROR:
        return {
          ...state,
          isError: true,
          isLoading: false,
          specErrors: action.payload,
        };
    case Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_REQUEST:
      return {
          ...state,
          isLoading: true,
          isError: false,
          specErrors: [],
          updateAPISettingSpecDefaultProxyStatus: '',
      };
    case Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        specErrors: [],
        updateAPISettingSpecDefaultProxyStatus: Constants.SUCCESS,
      };
    case Constants.API_SETTINGS_UPDATE_SPEC_DEFAULT_PROXY_ERROR:
      {
        const specErrorMessage = getValidationErrorMessage(action.payload);
        return {
          ...state,
          isError: true,
          isLoading: false,
          ...(specErrorMessage ? { specErrorMessage } : {}),
          updateAPISettingSpecDefaultProxyStatus: Constants.FAIL,
        };
      }
    case Constants.API_SETTINGS_UPDATE_REQUEST:
      return {
          ...state,
          isLoading: true,
          isError: false,
          errors: [],
          updateAPISettingsStatus: '',
      };
    case Constants.API_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        updateAPISettingsStatus: Constants.SUCCESS,
      };
    case Constants.API_SETTINGS_UPDATE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload.message,
        updateAPISettingsStatus: Constants.FAIL,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'apiSettings.isLoading');

export const getIsError = (state) => get(state, 'apiSettings.isError');

export const getErrors = state => get(state, 'apiSettings.errors');

export const getUpdateAPISettingsStatus = state => get(state, 'apiSettings.updateAPISettingsStatus');

export const getupdateAPISettingSpecDefaultProxyStatus = state => get(state, 'apiSettings.updateAPISettingSpecDefaultProxyStatus');

export const getAPISettings = state => get(state, 'apiSettings.data');

export const getSpecErrorMsg = (state) => get(state, 'apiSettings.specErrorMessage');

export const getAPISettingsSpecDefaultProxy = (state) => (
  get(state, 'apiSettings.specDefaultProxyData.value')
);
export const getAPISettingsEnforceCategoryOrdering = (state) => (
  get(state, 'apiSettings.enforceCategoryOrderingData.value') === 'true'
);
